import { CustomValueSettingEntityBase } from "@/entities/interfaces/i-custom-value-setting";

export default class PartnerIntraCustomValueSettingEntity extends CustomValueSettingEntityBase {
}
